import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './containers/Login';
import Home from './containers/Home';
import Tracking from './containers/Tracking';
import Scanner from './containers/Scanner';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/tracking" element={<Tracking />} />
        <Route path="/scanner" element={<Scanner />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
